import * as URLUtils from '@avcan/utils/url'

export function join(...path) {
    return URLUtils.buildPath(process.env.NEXT_PUBLIC_AVCAN_ASSETS_URL, path)
}

export function images(...path) {
    return join('images', path)
}
